import { Component, OnInit } from '@angular/core';
import { Noticediary } from './noticediary';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
import {map} from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import {AppComponent} from '../../app.component';
import { AlertService } from '../../alertpopup/_alert';
declare var $: any;
export const MY_FORMATS = {
  parse: { dateInput: 'DD-MMM-YYYY' },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};
export interface NoticeCaseStatus {
  NoticeStatus: string;
  ConvertinCase: string;
}
export interface CaseNotice {
  ID: number;
  refno: string;
  type: string;
  NoticeDt: any;
}
@Component({
    selector: 'app-notice-diary',
    templateUrl: './notice-diary.component.html',
    styleUrls: ['./notice-diary.component.css'],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})
export class NoticeDiaryComponent implements OnInit {
  url: string;
  PlanForForm: FormGroup;
  Noticeid: number;
  numb: any;
  pageurl: string;
  minDate = new Date();
  maxDate = new Date(2030, 0, 1);
  PlanDate: string;
  Manager: any;
  planActionType: any;
  ButtonCaption: string;
  contextID: any;
  editable: boolean;
  SelectedCaseNotice: number;
  CaseNoticeList: CaseNotice[] = [];
  Type: any;
  TypeID: any;
  FlowID:any;
  DateofDecision:any;
  currentDate =new Date();
  RuleNPolicyBackDate:string;
  CheckTargetDateFollowup:any;
  bindData: string;
  HideButtonSubmit: string;
  NoticeCaseStatus: string;
  RightsID: string;
  RouteGMPlanActionType: string;
  RouteUserMaster: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  // tslint:disable-next-line: max-line-length

// Context Type Options
  contextTypes = [
    { id: '2', name: 'Case' },
    { id: '1', name: 'Decision' },
    { id: '0', name: 'Notice' }
  ];

  // Alert Types
  alertTypes = [
    { id: '0', name: 'No Alert' },
    { id: '1', name: 'Minute' },
    { id: '2', name: 'Hour' },
    { id: '3', name: 'Day' }
  ];
    constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, public datepipe: DatePipe, protected alertService: AlertService ) {
    this.url = AppComponent.baseURL;
  }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    if (this.RightsID.includes('202024001') || this.RightsID.includes('202024021') || this.RightsID.includes('202024000')) {
  } else {
    window.location.href = "module/0";
  }
  // tslint:disable-next-line: max-line-length
    this.RouteGMPlanActionType = this.RightsID.includes('202042000') || this.RightsID.includes('202042001') || this.RightsID.includes('202042021') ? 'general-master/060' : 'module/0';
  // tslint:disable-next-line: max-line-length
    this.RouteUserMaster = this.RightsID.includes('202040000') || this.RightsID.includes('202040001') || this.RightsID.includes('202040021') ? 'user-master' : 'module/0';

    this.HideButtonSubmit = "";
     /********** For Get Contact Manager Name ******  !isHidden */
    this.http.get(this.url + 'GM/GetEmployee') .subscribe( (data) => {
      this.Manager = JSON.parse(data.toString());
    } );
    this.GetRuleNPolicy();
    // 060= Diary Plam Type
    this.getMaster('060', '') .subscribe( (data: any) => {
      this.planActionType = data; });
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.Noticeid = +pagehead[2];
    this.contextID = pagehead[3];
    this.Type = pagehead[4];
    if (this.contextID > 0) {
      if (this.Type == 1) {
        this.http.get(this.url + 'CorporateDecision/Fetch_PlanningStatus_Convert?PlanningID=' + this.Noticeid)
        .subscribe( (data) =>   {
            if (data == null) {
            } else {
             this.HideButtonSubmit = "!isHidden";
           }
           }
        );
      }
      if (this.Type == 0 || this.Type == 2) {
        this.http.get(this.url + 'Notice/Fetch_Notice_Case_Status?id=' + this.Noticeid)
        .subscribe( (data) =>   {
            if (data == null) {
            } else {
              const noticeCaseStatus: NoticeCaseStatus = JSON.parse(data.toString())[0];
              this.NoticeCaseStatus = noticeCaseStatus.NoticeStatus;
              if (this.NoticeCaseStatus == "1") {
             this.HideButtonSubmit = "!isHidden"; }
           }
           }
        );
      }
    }

    if (this.Type == 0 || this.Type == 2) {this.TypeID = 0; } else {
       this.TypeID = 0;
     }
    this.FetchHelpCaseNotice();
    if (this.Noticeid > 0 || this.contextID > 0) {
      this.PlanForForm = this.formBuilder.group({
      InTime: [''], PlanActionType: [null, Validators.required], PlanActionfor: [null], AlertTime: [''], AlertType: [''],
      SendNow: [''], PlanDate: ['', Validators.required], PlanDescription: ['', Validators.required], IsDone: [''],
      drpCaseNotice: [{value : this.Noticeid, disabled: true}], ContextType: [{value: this.Type, disabled: true}] });
    } else if (this.Type < 4) {
      this.PlanForForm = this.formBuilder.group({
        InTime: [''], PlanActionType: [null, Validators.required], PlanActionfor: [null], AlertTime: [''], AlertType: [''],
        ContextType: [{ disabled: true}], SendNow: [''], PlanDate: ['', Validators.required], IsDone: [''],
        PlanDescription: ['', Validators.required], drpCaseNotice: [null, Validators.required]});
      } else {
        this.PlanForForm = this.formBuilder.group({
          InTime: [''], PlanActionType: [null, Validators.required], PlanActionfor: [null], AlertTime: [''], AlertType: [''],
          ContextType: [''], SendNow: [''], PlanDate: ['', Validators.required], IsDone: [''],
          PlanDescription: ['', Validators.required], drpCaseNotice: [null, Validators.required]});
        }
    this.PlanForForm.patchValue({IsDone: "0" });
    if (this.contextID == "0")  {
       this.ButtonCaption = "Add";
     } else {
       this.ButtonCaption = "Update";
       this.FetchDiaryPlan();
     }

    this.PlanForForm.patchValue({
       PlanActionType: null, AlertTime: "0", AlertType: "0", ContextType: null,
       PlanActionfor: +localStorage.getItem('LoginUserID') });

  }

  get f () { return this.PlanForForm.controls; }
  getMaster(GID: string, MID: string) {
    return this.http.get(this.url + 'GM/GetMaster?GenID=' + GID + '&MainID=' + MID)
    .pipe(map(data => data = (data == null ? null : JSON.parse(data.toString()))));
    }

    FetchDiaryPlan() {
      this.http.get(this.url + 'Notice/FetchPlanDiary?DiaryID=' + this.contextID)
      .subscribe( (data) =>   {
          if (data == null) {  } else {
            const NoticeDiary: Noticediary = JSON.parse(data.toString())[0];
            let latest_date = this.datepipe.transform(NoticeDiary.PlanDate, 'yyyy-MM-dd');
            this.PlanForForm.patchValue({
                InTime: NoticeDiary.PlanInTimeHR + ':' + NoticeDiary.PlanInTimeMin, PlanActionType: NoticeDiary.PlanType,
                PlanActionfor: NoticeDiary.ResponsibleUserID, AlertTime: NoticeDiary.AlertTime, AlertType: NoticeDiary.AlertValue,
                PlanDate: latest_date, PlanDescription: NoticeDiary.PlanDescr});
          }
         }
      );
    }
    FetchHelpCaseNotice() {
      if (this.Type == 0 || this.Type == 4) {
        this.TypeID=0;
        this.bindData = 'Help/FetchHelpRefNoNotice?id=' + this.contextID;
      } else if (this.Type == 1) {
        this.TypeID=1;
        this.bindData = 'Help/FetchHelpRefNoPlanning?id=' + this.contextID;
      } else if (this.Type == 2) {
        this.TypeID=0;
        this.bindData = 'Help/FetchHelpRefNoCase?id=' + this.contextID;
      }

      this.http.get(this.url + this.bindData)
      .subscribe( (data) =>   {
          if (data == null) {
            this.CaseNoticeList = null;
          } else {
            this.CaseNoticeList = JSON.parse(data.toString());
            if (this.Noticeid > 0) {
              this.SelectedCaseNotice = this.Noticeid; }
            if (this.Type == 4) { this.PlanForForm.patchValue({ ContextType: '0' });
          } else {
            this.PlanForForm.patchValue({ ContextType: this.Type }); }
          }
         }
      );
    }
    onChangeContextType(GetContextType) {
      this.Type = GetContextType.id;
      this.FetchHelpCaseNotice();
    }
    GetRuleNPolicy() {
    
      this.http.get(this.url +  'SysData/GetRuleNPolicy?GenID=250&MainID=1&SubId=2')
     .subscribe( (data) =>   {
         if (data == null) {
           this.RuleNPolicyBackDate="0";
         } 
         else {
         
           this.FlowID = JSON.parse(data.toString())[0];
           this.RuleNPolicyBackDate = this.FlowID.RuleNPolicyBackDate;
           
              }
        }
     );
 }

 onPlanSubmit(PlanFormControl) {
  
  if(PlanFormControl.drpCaseNotice ==null)
  {
    if(PlanFormControl.ContextType=="0"){ this.alertService.showWarning('Please Select Notice No.'); return; }
    if(PlanFormControl.ContextType=="1"){ this.alertService.showWarning('Please Select Planning No.'); return; }
    if(PlanFormControl.ContextType=="2"){ this.alertService.showWarning('Please Select Case No.'); return; }

  }
  if (this.Noticeid == 0) {
    this.Noticeid = PlanFormControl.drpCaseNotice; }
  if (PlanFormControl.PlanDescription == "") {
    this.alertService.warn('Please Enter Plan Description' , this.options);
  } else {
     if (this.PlanForForm.invalid) { return; }
     this.numb = 1;

     let ND: Noticediary = {
      id: this.contextID,
      PlanType: PlanFormControl.PlanActionType,
      PlanDescr: PlanFormControl.PlanDescription,
      PlanDate: PlanFormControl.PlanDate,
      PlanInTimeHR: PlanFormControl.InTime.split(':')[0],
      PlanInTimeMin: PlanFormControl.InTime.split(':')[1],
      ResponsibleUserID: PlanFormControl.PlanActionfor,
      AlertTime: PlanFormControl.AlertType,
      AlertValue: PlanFormControl.AlertTime,
      NoticeID: this.Noticeid,
      RecUser: this.numb,
      Type: this.TypeID,
      FollowUpID: 0
    }
     this.http.post(this.url + 'Notice/insertNoticeDiary', ND) .subscribe( (data) => {
            if (data == null) {
              this.alertService.showError('Something went wrong');
            } else {
              if (this.contextID == "0" )  {
                this.alertService.showSuccess('Data submitted successfully');
                this.PlanForForm.patchValue({
                  PlanActionType: "0", AlertTime: "0", AlertType: "0",
                  PlanActionfor: localStorage.getItem('LoginUserID'), PlanDescription: "" ,  drpCaseNotice: null });

                } else {
                  this.alertService.showSuccess('Data updated successfully');
                   }
            }
           }
         );
 }
}
 

    onPlanFormSubmit(PlanFormControl) {
      if (this.PlanForForm.invalid) { 
        this.PlanForForm.markAllAsTouched();
        return;
      }
      this.http.get(this.url + 'CorporateDecision/Fetch_Existing_Notice_Planning?ID=' + this.Noticeid)
      .subscribe( (data) =>   {
        
          if (data == null)
           { 
            this.onPlanSubmit(PlanFormControl);
           } 
          else 
          {
            this.CheckTargetDateFollowup = JSON.parse(data.toString())[0];
  
            this.DateofDecision = this.CheckTargetDateFollowup.DateofDecision;
            if(this.RuleNPolicyBackDate=="0")
            {
              if(this.datepipe.transform(PlanFormControl.PlanDate,"yyyy-MM-dd")>this.datepipe.transform(this.currentDate,"yyyy-MM-dd"))
              {
                this.alertService.showWarning("Please Selected Follow up  Date Only Current Date,because Back Date entry is not Allowed");
                return;
              }
             
              this.onPlanSubmit(PlanFormControl);
            } 
  
            else if(this.RuleNPolicyBackDate=="1")
            {
              
              if(this.datepipe.transform(PlanFormControl.PlanDate,"yyyy-MM-dd")<this.datepipe.transform(this.DateofDecision,"yyyy-MM-dd"))
              {
                this.alertService.showWarning("Please Selected Follow up  Date Only Less Than current date or greater than Date of decision ,because Back Date entry is not Allowed");
                return;
              }
              this.onPlanSubmit(PlanFormControl);
            } 
  
            else
            {
              
              this.onPlanSubmit(PlanFormControl);
            } 
            
           
            
          
          }
         }
      );
    }
}
